const mapStateToProps = state => 
     ({
        data: state.constanciaCandidatoEleccionPopular.data||[],

    });

export default mapStateToProps;
